import BrochureRequest from '@bridebook/web/app-basic/components/supplier/sections/sticky-brochure-request/brochure-request';
import StickyBrochureRequestComp from '@bridebook/web/app-shared/components/supplier/sections/sticky-brochure-request';

interface IProps {
  containerRef?: React.RefObject<HTMLElement>;
}

const StickyBrochureRequest = ({ containerRef }: IProps) => (
  <StickyBrochureRequestComp containerRef={containerRef}>
    <BrochureRequest />
  </StickyBrochureRequestComp>
);

export default StickyBrochureRequest;
